import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { forkJoin } from "rxjs";
import { GlobalVariable } from "../../app.component";
import { DataService } from "../../dataService/data.service";
import { CommonService } from "../../services/common.service";

@Component({
  selector: "app-overall-reviews",
  templateUrl: "./overall-reviews.component.html",
  styleUrls: ["./overall-reviews.component.scss"],
})
export class OverallReviewsComponent implements OnInit {
  /** Global variable declaration */
  @Input() before_join_zceppa: any;
  @Input() isTotalReviewAvailable: boolean;
  @Input() connectedPlatforms: any = null;
  @Output() isReviewAvailable = new EventEmitter<boolean>();

  public loading = false;
  private BASE_URL = GlobalVariable;
  currentRate = 4.5;
  outletId: string;
  totalReviews: String;
  averageRatings: String;
  googleOverallRating: any = null;
  facebookOverallRating: any = null;
  zceppaOverallRating: any = null;
  totalReviewsTitle = "TOTAL REVIEWS";
  overallRating = "OVERALL RATING";
  positiveReviewCount: Number;
  negativeReviewCount: Number;

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private HttpService: DataService,
    private commonservice: CommonService
  ) {}

  ngOnInit() {
    this.loading = true;
    console.log("before_join_zceppa", this.before_join_zceppa);

    this.commonservice.analytics_filter.subscribe((res) => {
      if (res !== null) {
        this.totalReviews = res.total_reviews;
        this.averageRatings = res.average_rating;
        this.positiveReviewCount = res.total_positive_reviews;
        this.negativeReviewCount = res.total_negative_reviews;
        this.googleOverallRating = res.google_overall_rating;
        this.facebookOverallRating = res.facebook_overall_rating;
        this.zceppaOverallRating = res.zceppa_rating;
        this.loading = false;
      }
    });
    this.outletId = this.storage.get("outlet_id");
    const obj = this.HttpService.get(
      this.BASE_URL.OVERALL_REVIEW_URL(this.outletId)
    );
    obj.subscribe(
      (res) => {
        if (res.code == 200) {
          this.totalReviews = res.data["total_reviews"];
          this.averageRatings = res.data["average_rating"];
          if (res.data["total_reviews"] > 0) {
            this.isReviewAvailable.emit(true);
          } else {
            this.isReviewAvailable.emit(false);
          }
          this.positiveReviewCount =
            Math.round(res.data["g_postive"]) +
            Math.round(res.data["f_positive"]) +
            Math.round(res.data["i_positive"]);
          this.negativeReviewCount =
            Math.round(res.data["g_negative"]) +
            Math.round(res.data["f_negative"]) +
            Math.round(res.data["i_negative"]);
          this.googleOverallRating =
            this.before_join_zceppa.data["google_overall_rating"];
          this.facebookOverallRating =
            this.before_join_zceppa.data["facebook_overall_rating"];
          this.zceppaOverallRating =
            this.before_join_zceppa.data["zceppa_rating"];
        }
        this.loading = false;
      },
      (error) => {}
    );
  }
}
